import { createUseStyles } from 'react-jss';
import { base } from '../../../css/vars';

export default createUseStyles({
  form: {
    '& > *:not(:last-child)': {
      marginBottom: base(),
    },
  },
});
